import React, { useState } from 'react';
import {changePasswordUrl} from '../../Routes/ApiRoutes';
import {Post} from '../../Api/ApiMethods';
import backArrow from '../../assets/images/arrow.svg';
import iconPasswordShow from '../../assets/images/passwordShow.svg';
import iconPasswordHide from '../../assets/images/passwordHide.svg'
import {
    PasswordValidation
  } from '../../utils/Validation.js';
  import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router';


export default function ChangePassword() {
    const token = useSelector((state) => state.auth.isSignedIn);
    const dispatch = useDispatch();
    const history = useHistory();
    const [passShow, setPassShow] = useState(false);
    const [data, setData] = useState({
        "password": "",
        "confirm_password": ""
    })

    const [passError, setPassError] = useState(null);
    const [confrmPassError, setConfrmPassError] = useState(null);


    const handleConfrmPassInput = (e) => {
        let updatedDetails = { ...data };
        updatedDetails[e.target.id] = e.target.value;
        setData(updatedDetails)
        if(data.password == e.target.value)
        { 
          setConfrmPassError(null);
        }
        else{
            setConfrmPassError('It does not match with password.');
        }
    }
    
    const handlePassInput = (e) => {
        let updatedDetails = { ...data };
        updatedDetails[e.target.id] = e.target.value;
        setData(updatedDetails)
        if(PasswordValidation(e.target.value))
        {
            setPassError(null);
        }
        else{
            setPassError('Must have at least one uppercase letter, one lowercase letter, one number and one of the special characters #?!@$%^&*-.');
        }
    }

    const handleSaveBtn = () => {
        if(data.password === '')
        {
          setPassError('Password cannot be blank.')
        }
        if(data.confirm_password === '')
        {
          setConfrmPassError('Confirm password cannot be blank.')
        }
        if(data.password !== '' && data.confirm_password !== '' && !(confrmPassError) && !(passError)){
          try {
                Post(changePasswordUrl, token, data)
                .then(res => { 
                    toast.success(res.message);
                    setTimeout(() => {
                        dispatch({
                            type: 'SIGN_OUT',
                        });
                        history.push(`/login`)
                    } ,2100);
                })
                .catch(error => {
                    toast.error(error.error)
                })
            }
            catch(error) {
                toast.error(error.error)
            }
        }
    }
    

    return (
        <>
            <section class="sign-in-wrapper Forgot-Wpassword">
                <div class="container">
                    <div class="sign-in">
                        <h3> 
                            <img src={backArrow} onClick={() => history.push('/profile')} />
                            <span>Set new password</span>
                        </h3>
                            <div class="form-group">
                                <input type="password" className={passError ? "form-control borderRed" : "form-control" } placeholder="New password" 
                                onChange={(e) => handlePassInput(e)} value={data.password} id='password' />
                                {passError && <span className='form-error'>{passError}</span>}
                            </div>
                            <div class="form-group">
                                <img className='inputImage' style={{visibility : data.confirm_password === '' ? 'hidden' : 'visible'}} 
                                    alt='emailClear' src={ passShow ? iconPasswordHide : iconPasswordShow} onClick={() => {
                                        let pass = document.getElementById('confirm_password');
                                        if(pass.type === 'text'){
                                            pass.type = 'password';
                                        }else{
                                            pass.type = 'text';
                                        }
                                        setPassShow(!passShow);
                                    }} />
                                <input value={data.confirm_password} id='confirm_password' onChange={(e) => handleConfrmPassInput(e)} 
                                type="password" className={confrmPassError ? "form-control borderRed" : "form-control" } placeholder="Confirm password" />
                                {confrmPassError && <span className='form-error'>{confrmPassError}</span>}
                            </div>
                        <div class="comman-btn">
                            <button onClick={() => handleSaveBtn()}>Submit</button>
                        </div> 
                    </div>
                </div>
            </section>
        </>
    )
}
